export default {
	'Abnormal problem, please contact the website administrator!': 'Abnormal problems, please contact the website administrator!',
	'Automatic cancellation due to duplicate request:': 'Automatic cancellation due to duplicate requests:',
	'Error requesting address:': 'Error requesting address:',
	'Gateway error!': 'Gateway error!',
	'HTTP version is not supported!': 'HTTP version is not Unsupported!',
	'Incorrect parameter!': 'Incorrect parameter!',
	'Interface redirected!': 'Interface redirected!',
	'Network request timeout!': 'Network request timeout!',
	'Operation successful': 'Operate successful',
	'Request timed out!': 'Request timeout!',
	'Server exception!': 'Server-side exceptions!',
	'Service not implemented!': 'Service unrealized!',
	'Service unavailable!': 'Service unavailable!',
	'The same data already exists in the system!': 'The same data already exists on the system!',
	'The service is temporarily unavailable Please try again later!': 'The service is temporarily unavailable, please try again later!',
	'You are disconnected!': 'You are disconnected!',
	'You do not have permission to operate!': 'You have no permission to operate!',
	'登录信息已失效，请重新登录': 'Your session has expired. Please sign in again.',
	'服务器内部错误！': 'Internal server error!',
	确定: 'OK',
	系统提示: 'System notice',
}
